import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { FaInfoCircle } from "react-icons/fa"
import Trainer from "../components/trainer"
import Title from "../components/title"

// Styles
import styles from "../styles/components/team.module.scss"

const Team = () => {
  const data = useStaticQuery(graphql`
    query {
      chamika: file(relativePath: { eq: "new-trainer-portrait.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ayesh: file(relativePath: { eq: "ayesh-portrait-final.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      almeda: file(relativePath: { eq: "almeda-portrait-final.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <div className={styles.main} id="team">
      <Title text="Meet Our Team" />

      <div className={styles.team}>
        {/* <Trainer
          image={data.avishka.childImageSharp.fluid}
          name="Avishka Senevirathana"
          insta="https://www.instagram.com/lifetime.fitness.by.maduranga/"
          fb="https://www.facebook.com/Lifetime-Fitness-422919781093919/"
        /> */}
        <Trainer
          image={data.ayesh.childImageSharp.fluid}
          name="Ayesh Ranasinghe"
          qualification1="National Diploma in Sports Strength and Conditioning (SLF)"
          qualification2="Certificate for Fitness Trainers (SLF)"
          insta="https://www.instagram.com/lifetime.fitness.by.maduranga/"
          fb="https://www.facebook.com/Lifetime-Fitness-422919781093919/"
        />
        <Trainer
          image={data.almeda.childImageSharp.fluid}
          name="Thumesh Almeda"
          qualification1="Physical Fitness Trainer (NVQ Level 4)"
          qualification2="Physical Fitness Instructor (National Institute Of Sports Science)"
          insta="https://www.instagram.com/lifetime.fitness.by.maduranga/"
          fb="https://www.facebook.com/Lifetime-Fitness-422919781093919/"
        />
        <Trainer
          image={data.chamika.childImageSharp.fluid}
          name="Chamika Ravishan"
          qualification1="Diploma in Sports Strength and Conditioning (NVQ Level 5)"
          qualification2="Certificate Level in Fitness Training and Instructing"
          insta="https://www.instagram.com/chamika_ravishan/"
        />
      </div>
      <div className={styles.footer}>
        <FaInfoCircle />
        <p className={styles.text}>
          All our trainers are qualified instructors with a passion for fitness
        </p>
      </div>
    </div>
  )
}

export default Team
